<template>
    <div style="height:100%;">
        <DxTabPanel style="height: 100%;transition:none;">
            <DxItem title="Fűtés leolvasási adatok" icon="home">
                <template #default>
                    <HeatingTableHeader></HeatingTableHeader>
                </template>
            </DxItem>
            <DxItem title="Melegvíz leolvasási adatok" icon="coffee">
                <template #default>
                    <HotWaterTableHeader></HotWaterTableHeader>
                </template>
            </DxItem>
            <DxItem title="Főtáv sablonok" icon="upload">
                <template #default>
                    <FotavInputTable></FotavInputTable>
                </template>
            </DxItem>
            <DxItem title="Főtáv szétosztási eredmények" icon="xlsfile">
                <template #default>
                    <FotavOutputTable></FotavOutputTable>
                </template>
            </DxItem>
        </DxTabPanel>
    </div>
</template>

<script>
    import HeatingTableHeader from "../components/HeatingTableHeader";
    import HotWaterTableHeader from "../components/HotWaterTableHeader";
    import FotavInputTable from "../components/FotavInputTable";
    import FotavOutputTable from "../components/FotavOutputTable";
    import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";

    export default {
        name: 'HeatCalculator',
        components: {
            HeatingTableHeader,
            HotWaterTableHeader,
            FotavInputTable,
            FotavOutputTable,
            DxTabPanel,
            DxItem
        }
    }
</script>

<style lang="scss" scoped>
    #mapScrollview {
        height: 100%;
    }
    .col-container {
        display: flex;
        width: 100%;
        min-height: calc(100vh - 86px);
    }
    .col {
        flex: 1;
        padding: 0;
    }
    .col-absolute {
        position: absolute;
        left: 300px;
        height: 100%;
        width: 100%;
    }
    .level {
        min-height: 200px;
    }
    .level:last-child {
        min-height: 0 !important;
        flex: 1;
    }
    .ruler:before {
        content: '';
        display: block;
        width: 20px;
        height: 30px;
        position: absolute;
        margin-top: -7px;
        border: 1px solid #808080;
        border-left: none;
        border-right: none;
        border-image-source: linear-gradient(to right, #000000, rgba(0, 0, 0, 0));
        border-image-slice: 1;
    }
    .grid {
        fill-opacity: 0;
    }
    ::v-deep .dx-diagram {
        border: none !important;
    }
    ::v-deep .dxdi-canvas .page {
        fill-opacity: 0;
    }
    ::v-deep .dx-diagram .dxdi-control .dxdi-canvas {
        background: none !important;
    }
    ::v-deep .dx-scrollable {
        width: 100%;
    }
    ::v-deep .dx-resizable-handle-bottom {
        height: 8px !important;
        width: 80px !important;
        margin-left: 22px;
    }
    ::v-deep .dx-scrollable-content {
        padding-bottom: 0 !important;
    }
    ::v-deep .dx-resizable-handle-bottom::after {
        content: '...';
        font-size: 15px;
        background-color: #f2f2f2;
        z-index: 100000000;
        position: absolute;
        display: block;
        line-height: 0px;
        bottom: 0px;
        padding-bottom: 7px;
        width: 80px;
        text-align: center;
        border: solid 1px #e1e1e1;
        border-radius: 3px 3px 0 0;
        line-height: 0px;
        border-bottom: none;
    }
    ::v-deep .dx-datagrid-header-panel .dx-toolbar {
        margin-top: 6px;
        margin-bottom: 6px;
        padding-right: 8px;
    }
    ::v-deep .dx-datagrid-edit-popup .dx-state-readonly {
        border: none !important;
    }
    .positionid {
        display: block;
        float: left;
        width: 19px;
        text-align: right;
        margin-right: 3px;
    }
    ::v-deep .dx-tag-container.dx-texteditor-input-container {
        padding-bottom: 0 !important;
    }
    ::v-deep .dx-datagrid-content .dx-datagrid-table .dx-row > td,
    .dx-datagrid-content .dx-datagrid-table .dx-row > tr > td {
        vertical-align: middle !important;
    }
    ::v-deep .dx-tag-content {
        padding: 4px 10px 4px 6px;
    }
    ::v-deep .dx-header-row .dx-text-content-alignment-left, .dx-header-row .dx-text-content-alignment-right {
        display: unset;
        max-width: 100%;
    }
    ::v-deep .dx-toolbar-text-auto-hide .dx-button .dx-icon {
        line-height: 20px;
    }
    ::v-deep .dx-toolbar .dx-toolbar-after {
        padding-left: 15px;
        padding-top: 0px;
    }
    ::v-deep .dx-icon-hierarchy2 {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAA8SURBVHjaYvz//z8DNQATA5UACy4JExMTrE49c+YMI01dNGoQYcA4eNMRoXRDSH40+kd0OgIAAAD//wMAg04VHWC0GqEAAAAASUVORK5CYII=);
        background-repeat: no-repeat;
        background-position: 0px 0px;
        margin-top: 5px !important;
    }
</style>